import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { FormProvider } from './hooks/context/FormContext ';
import { StepProvider } from './hooks/context/StepContext';
import { PriceProvider } from './hooks/context/PriceContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <StepProvider>
    <FormProvider>
    <PriceProvider>
    <App />
    </PriceProvider>
    </FormProvider>
    </StepProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

